// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import refreshCcw01Icon from "@/assets/icons/refresh-ccw-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type RefreshCcw01IconProps = Omit<IconProps, "name">;

export function RefreshCcw01Icon(props: RefreshCcw01IconProps): React.ReactNode {
  return <Icon name={refreshCcw01Icon} {...props} />;
}
